var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hazardous_waste",attrs:{"id":"hazardous_waste_ship"}},[(_vm.receivedData)?_c('div',[_c('TabsCustomGraphic',{attrs:{"received-data":_vm.receivedData,"data-labels":false,"id":"hazardous"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }